"use client";
import { useLoadScript } from "@react-google-maps/api";
import Places from "../PlacesInput";
import classes from "./MapAndPlaces.module.css";
import { googleMapApiKey } from "@/constant/constants";
import MapEditView from "../MapEditView";
import MapView from "../MapView";

// type = 'map' || 'places' || 'editAbleMap'
const Maps = ({
  type = "map",
  className,
  mapClass,
  placeClass,
  setCoordinates,
  setAddress,
  address,
  setPlaceDetail,
  location,
  placeholder,
  label,
  leftIcon,
  data,
  loader,
  propertiesData,
  showCircle,
  miles,
  zoom,
  viewCard,
  navigateFilterData,
  error,
  errorText,
  filterStateName,
}) => {
  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: googleMapApiKey,
    libraries: ["places", "visualization"],
  });
  if (!isLoaded) {
    return loader ? (
      loader
    ) : (
      <div className={classes?.loadingContainer}>Loading</div>
    );
  }

  if (loadError) {
    return (
      <div className={classes?.ErrorContainer}>
        <span>Map cannot be loaded right now, sorry. </span>
      </div>
    );
  }

  return (
    <div className={`${classes.Container} ${className ? className : ""}`}>
      {type === "map" ? (
        <MapView
          data={data}
          location={location}
          className={mapClass}
          showCircle={showCircle}
          zoom={zoom}
        />
      ) : type === "editAbleMap" ? (
        <MapEditView
          coordinates={location}
          setCoordinates={setCoordinates}
          setAddress={setAddress}
          setPlaceDetail={setPlaceDetail}
          className={mapClass}
        />
      ) : (
        <Places
          setCoordinates={setCoordinates}
          setAddress={setAddress}
          address={address}
          className={placeClass}
          placeholder={placeholder}
          setPlaceDetail={setPlaceDetail}
          label={label}
          leftIcon={leftIcon}
          error={error}
          errorText={errorText}
          filterStateName={filterStateName}
        />
      )}
    </div>
  );
};

export default Maps;
